<template>
	<div v-if="worker">
		<b-row class="justify-content-lg-center">
			<b-col>
				<b-card-title>{{ worker.firstname }} {{ worker.lastname }}</b-card-title>
                <b-list-group>
                    <b-list-group-item>
                        <b-row>
                            <b-col>
                                <b>{{ $t('worker_label_is_active') }}:</b>
                            </b-col>
                            <b-col cols="8">
                                {{ worker.isActive ? $t('app_yes') : $t('app_no') }}
                            </b-col>
                        </b-row>
                    </b-list-group-item>
                </b-list-group>
			</b-col>
		</b-row>
		<b-row class="justify-content-lg-center">
			<b-col>
                <hr />
                <a :href="`/worker`" type="button" class="btn btn-secondary">{{ $t('worker_button_back_to_list') }}</a>
                <a :href="`/worker/${worker.id}/edit`" type="button" class="btn btn-primary ml-2">{{ $t('worker_button_edit') }}</a>
			</b-col>
		</b-row>
	</div>
</template>

<script>
export default {
    name: 'WorkerShow',
    props: ['worker'],
}
</script>